import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import Button, { ButtonProps } from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { FC, MouseEvent, useState } from 'react'

interface IMenuItem {
    onClick: (MouseEvent) => void
    label: string
    selected?: boolean
}

interface MenuButtonProps extends ButtonProps {
    label: string
    menuItems: IMenuItem[]
    closeOnClick?: boolean
    hideArrow?: boolean
}

const MenuButton: FC<MenuButtonProps> = ({
    label,
    menuItems,
    closeOnClick = true,
    hideArrow = false,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const endIcon = hideArrow ? undefined : open ? (
        <ArrowDropUp />
    ) : (
        <ArrowDropDown />
    )

    const renderMenuItems = menuItems.map(({ label, onClick, selected }) => (
        <MenuItem
            key={label}
            onClick={(e) => {
                onClick(e)
                if (closeOnClick) handleClose()
            }}
            selected={selected}
        >
            {label}
        </MenuItem>
    ))

    return (
        <div>
            <Button
                id="menu-button"
                aria-controls={open ? 'button-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                endIcon={endIcon}
                {...props}
            >
                {label}
            </Button>
            <Menu
                id="button-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'menu-button',
                }}
            >
                {renderMenuItems}
            </Menu>
        </div>
    )
}

export default MenuButton
